<template>
    <div class="auction">
        <div v-show="routerLevel === 2">
            <div class="common-search-container common-shadow">
                <div class="common-header">
                    搜索筛选
                </div>
                <div class="content">
                    <el-form
                        :inline="true"
                        :model="searchParams"
                        @submit.native.prevent="getData">
                        <el-form-item>
                            <el-input
                                v-model="searchParams.name"
                                placeholder="属性名称"
                                clearable />
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                round
                                @click="getData">
                                查询
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
                <div class="common-table-title">
                    <span class="tit">
                        数据列表
                    </span>
                    <el-button
                        type="primary"
                        @click="openDialog(null)"
                        round>
                        添加
                    </el-button>
                </div>
                <el-table
                    class="table common-shadow"
                    stripe
                    :data="tableData"
                    v-loading="loading">
                    <el-table-column
                        prop="id"
                        label="ID"
                        min-width="80" />
                    <el-table-column
                        prop="name"
                        label="名称"
                        min-width="100" />
                    <el-table-column
                        prop="time"
                        label="添加时间"
                        min-width="150">
                        <template slot-scope="scope">
                            {{ dateFormat(scope.row.time) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作"
                        min-width="100">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="openDialog(scope.row.id, scope.row.name)">
                                编辑
                            </el-button>
                            <el-button
                                type="text"
                                @click="del(scope.row.id)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="common-table-pagination">
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page="searchParams.page"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="dataTotal" />
                </div>
            </div>
        </div>
        <input-dialog
            ref="complaintDialog"
            :title="inputDialog.title"
            :label="inputDialog.label"
            :placeholder="inputDialog.placeholder"
            :success-tip="inputDialog.successTip"
            :input-type="inputDialog.inputType"
            :rules="inputDialog.rules"
            :api-fn="inputDialog.apiFn"
            @done="onInputDialogDone" />
    </div>
</template>

<script>
import { getAttributeList, addAttribute, delAttribute, editAttribute } from '../../../api';
import { dateFormat } from '../../../utils/util';
import { openComfirm } from '../../../utils/common';
import InputDialog from '../../../components/inputDialog/InputDialog';

export default {
    name: 'AttributeList',
    props: {
        routerLevel: {
            type: Number,
            default: 2,
            required: true
        }
    },
    data () {
        const validateName = (rule, value, callback) => {
            const { _repeatName } = this;
            if (_repeatName === null) {
                callback();
            } else {
                if (_repeatName === this._complaintDialog.formData.msg) {
                    callback(new Error('属性名称重复'));
                } else {
                    callback();
                }
            }
        };
        return {
            loading: true,
            tableData: [],
            category: [],
            auctionStatus: Object.create(null),
            searchParams: {
                name: '',
                page: 1
            },
            pageSize: 0,
            dataTotal: 0,
            inputDialog: {
                title: '添加属性',
                label: '名称',
                inputType: 'text',
                successTip: '添加成功！',
                placeholder: '请输入属性名称',
                rules: {
                    msg: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        { validator: validateName, trigger: 'blur' }
                    ]
                },
                apiFn: input => {
                    const name = input.trim();
                    this._repeatName = name;
                    const { _currentId } = this;
                    if (!_currentId) {
                        return addAttribute({ name });
                    } else {
                        return editAttribute(_currentId, { name });
                    }
                }
            }
        };
    },
    created () {
        this._currentId = null;
        this._repeatName = null;
        this._complaintDialog = null;
        this.$nextTick(() => {
            this._complaintDialog = this.$refs.complaintDialog;
        });
        this.getData();
    },
    beforeRouteUpdate (to, from, next) {
        if (to.name === 'auction.index') this.getData(this.searchParams.page);
        next();
    },
    methods: {
        async getData (page) {
            try {
                this.loading = true;
                if (page && typeof page === 'number') {
                    this.searchParams.page = page;
                } else {
                    this.searchParams.page = 1;
                }
                const res = await getAttributeList(this.searchParams);
                this.loading = false;
                if (res) {
                    const { data, meta, type, category } = res;
                    this.tableData = data;
                    if (type) this.auctionStatus = type;
                    if (category) this.category = category;
                    if (meta) {
                        this.dataTotal = meta.total;
                        this.pageSize = meta.per_page;
                    }
                }
            } catch (err) {
                console.error(err);
                this.loading = false;
            }

        },
        goDetails (id) {
            this.$router.push({
                name: 'auction.show',
                params: {
                    id
                }
            });
        },
        handleCurrentChange (val) {
            this.getData(val);
        },
        openDialog (id, name) {
            const { inputDialog } = this;
            if (id) {
                this._currentId = id;
                inputDialog.title = '编辑属性';
                inputDialog.successTip = '编辑成功！';
            } else {
                this._currentId = null;
                inputDialog.title = '添加属性';
                inputDialog.successTip = '添加成功！';
            }
            this._complaintDialog.open(name);
        },
        onInputDialogDone (err) {
            if (!err) {
                this._repeatName = null;
                this.getData();
            } else {
                if (err && err.data && err.data.code === 422) {
                    this._complaintDialog.validateField();
                }
            }
        },
        async del (id) {
            try {
                this._repeatName = null;
                const apiFn = (id) => {
                    return () => {
                        return delAttribute(id);
                    };
                };
                await openComfirm({
                    title: '提示',
                    message: '您确定要删除吗？',
                    successTip: '删除成功!',
                    apiFn: apiFn(id)
                });
                this.getData(this.searchParams.page);
            } catch (err) {
                console.error(err);
            }
        },
        dateFormat (time) {
            if (!time) return '';
            return dateFormat(new Date(time * 1000), 'yyyy/MM/dd hh:mm');
        }
    },
    components: {
        InputDialog
    }
};
</script>

<style lang="scss" scoped>
    .auction {

        .table {

            img {
                width: 32px;
                height: 32px;
                object-fit: cover;
            }
        }
    }
</style>
